function webinarModal() {
	let modal = document.querySelector('.js-flex-academy-webinar-form');
	
	if (modal) {
		let modalBtns = document.querySelectorAll('.js-webinar-modal-btn');
		let overlay = document.querySelector('.js-modal-overlay-dark');
		let closeBtn = modal.querySelector('.js-modal-close');

		function openModal() {
			modal.classList.add('open');
			overlay.classList.add('open');
		}

		function closeModal() {
			modal.classList.remove('open');
			overlay.classList.remove('open');
		}

		modalBtns.forEach(function (btn) {
			btn.addEventListener('click', function (e) {
				e.preventDefault();

				openModal();
			});
		});

		closeBtn.addEventListener('click', closeModal);

		overlay.addEventListener('click', function (event) {
			if (event.target === overlay) {
				closeModal();
			}
		});
	}
}

export default webinarModal;
